/**
 * @see https://oss.navercorp.com/place/my_plan/issues/5055
 * 헤더 우측 상단에 프로필모양의 홈버튼 노출 관련 훅
 */

import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import useIsPreviousInternalRouting from '@web/hooks/useIsInternalRouting'
import useMe from '@web/hooks/useMe'
import { useNavigation } from '@web/hooks/useNavigation'

export const useProfileMy = () => {
  const navigation = useNavigation()
  const { isFromMapsApp } = useGlobalStaticStateContext()
  const showProfileMy = !(useIsPreviousInternalRouting() || isFromMapsApp)
  const { me } = useMe()

  const handleClickCloseButton = () => navigation.back()
  const handleClickBackButton = () => navigation.back()
  const handleClickProfileMyButton = () => navigation.goToMy()

  return {
    showProfileMy,
    handleClickBackButton,
    handleClickCloseButton,
    handleClickProfileMyButton,
    profileImageUrl: me?.profile?.imageUrl,
    borderImageUrl: me?.profile?.border?.imageUrl,
  }
}
